/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Authorization Codes)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form state values for Authorization Codes.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Default form state
 */
export function getDefaultFormState(): FormState {
  return {
    code: '',
    alias: '',
    description: '',
    cosId: null,
    active: true
  };
}

